<template>
    <div id="MyPost">
        <div class="post-content">
            <div class="post-nav">
                <div
                    class="nav-item"
                    v-for="(item, index) of nav"
                    :key="index"
                    @click="changeNav(item, index)"
                >
                    <div :class="`item-hover ${index !== navIndex ? 'item-hover-null' : null}`"></div>
                    {{item.name}}
                </div>
            </div>
            <div class="post-list">
                <div class="post-tab">
                    <div
                        class="tab-item"
                        v-for="(item, index) of navIndex === 0 ? myPost : appointmentList"
                        :key="index"
                        @click="changeTab(item, index)"
                    >
                        <span :class="{'nav-focus': index === tabIndex}">{{item.name}}</span>
                        <span v-if="index !== appointmentList.length - 1">|</span>
                    </div>
                </div>
                <div class="item-block" v-if="navIndex === 0">
                    <div
                        class="item-block-item"
                        v-for="(item, index) of postList"
                        @click="toDetails(item)"
                        :key="index">
                        <div class="item-block-banner">
                            <img :src="item.imgUrl && item.imgUrl" alt="">
                        </div>
                        <div class="item-block-info">
                            <p>
                                <span>{{item.title}}</span>
                                <img src="../../assets/img/delete.png" title="删除" alt="" @click.stop="toDelete(item.id)">
                            </p>
                            <p>审核状态: {{item.status === 1 ? '审核中' : item.status === 2 ? '审核通过' : '审核不通过'}}</p>
                            <p>
                                <img src="../../assets/img/时间.png" alt="">
                                <span>{{item.createTime}}</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="item-block" v-if="navIndex === 1 && tabIndex === 0">
                    <div
                        class="item-block-item"
                        v-for="(item, index) of appointmentData"
                        :key="index">
                        <div class="item-block-banner">
                            <img :src="item.fishsite && item.fishsite.attachments[0].fileUrl"
                                 alt="">
                        </div>
                        <!--{{JSON.stringify(item.fishsite.attachments[0])}}-->
                        <div class="item-block-fishsite">
                            <p>{{item.fishsite.name}}</p>
                            <div class="fishsite-type">
                                <div class="fishsite-type-item" v-for="(fish, index) of item.fishsite.fishes.split(',')"
                                     :key="index">
                                    {{fish}}
                                </div>
                            </div>
                            <div>
                                <img src="../../assets/img/地图.png" alt="">
                                <span>{{item.fishsite && item.fishsite.address}}</span>
                            </div>
                            <div>
                                <img src="../../assets/img/预约.png" alt="">
                                <span>当前预约:</span>
                                <span>{{item.fishsite && item.fishsite.appointNums}}人</span>
                            </div>
                            <div>
                                <img src="../../assets/img/时间.png" alt="">
                                <span>开放时间:</span>
                                <span>{{item.fishsite && item.fishsite.openTime}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item-block" v-if="navIndex === 1 && tabIndex === 1">
                    <div
                        class="item-block-item"
                        v-for="(item, index) of appointmentData"
                        :key="index">
                        <div class="item-block-banner">
                            <img :src="item.ship && item.ship.attachments[0].fileUrl"
                                 alt="">
                        </div>
                        <!--{{JSON.stringify(item.fishsite.attachments[0])}}-->
                        <div class="item-block-fishsite">
                            <p>{{item.ship && item.ship.numberPlate}}</p>
                            <!--<div class="fishsite-type">-->
                            <!--    <div class="fishsite-type-item" v-for="(fish, index) of item.fishsite.fishes.split(',')"-->
                            <!--         :key="index">-->
                            <!--        {{fish}}-->
                            <!--    </div>-->
                            <!--</div>-->
                            <div>
                                <img src="../../assets/img/地图.png" alt="">
                                <span>登船码头:</span>
                                <span>{{item.wharfName && item.wharfName}}</span>
                            </div>
                            <div>
                                <img src="../../assets/img/时间.png" alt="">
                                <span>预约时间:</span>
                                <span>{{item.yyDate && item.yyDate}}</span>
                            </div>
                            <div>{{item.totalPrice}}</div>
                        </div>
                    </div>
                </div>
                <div class="pagination-post" v-if="navIndex === 0">
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        @current-change="currentChange"
                        :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'MyPost',
        data() {
            return {
                nav: [
                    {name: '我的帖子'},
                    // {name: '我的收藏'},
                    {name: '我的预约'}
                ],
                appointmentList: [
                    {name: '钓场预约'},
                    {name: '船舶预约'}
                ],
                myPost: [
                    {name: '我的帖子'}
                ],
                postList: '',
                appointmentData: '',
                navIndex: 0,
                tabIndex: 0,
                pageNum: 1,
                pageSize: 10,
                total: 0,
                fishsiteOrder: '',
                shipOrder: ''
            }
        },
        methods: {
            // 更改nav左侧主导航栏
            changeNav(item, index) {
                this.navIndex = index
                switch (index) {
                    case 0:
                        this.pageNum = 0
                        this.getData()
                        break
                    case 1:
                        this.getAppointmentList(0)
                        break
                }
            },
            // 更改tab
            changeTab(item, index) {
                this.tabIndex = index
                switch (item.name) {
                    case '钓场预约':
                        this.getAppointmentList(0)
                        break
                    case '船舶预约':
                        this.getAppointmentList(1)
                        break
                }
            },
            getData() {
                this.$common.querystringifyPost('/hdweb/portal/getMyPosting', {
                    pageNum: this.pageNum,
                    pageSize: this.pageSize
                }).then(res => {
                    this.postList = res.data.data.rows
                    this.total = res.data.data.total
                })
            },
            /**
             * 我的预约
             * @param status 0 钓场预约, 1船舶预约
             */
            getAppointmentList(status) {
                this.$common.querystringifyPost('/hdweb/portal/getMyOrder').then(res => {
                    if (res.data.code === 0) {
                        if (status === 0) {
                            this.appointmentData = res.data.data.fishsiteOrder
                        } else if (status === 1) {
                            this.appointmentData = res.data.data.shipOrder
                        }
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            },
            currentChange(pageNum) {
                console.log(pageNum)
                this.pageNum = pageNum
                this.getData()
            },
            /**
             * 跳转详情 info的详情
             */
            toDetails(item) {
                this.$router.push({
                    path: '/InfoDetails',
                    query: {
                        id: item.id,
                        type: 'kan'
                    }
                })
            },
            toDelete(id) {
                this.$confirm('此操作将永久删除该帖子, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$common.querystringifyPost('/hdweb/portal/deletePosting', {id: id}).then(res => {
                        console.log(res)
                        if (res.data.code === 0) {
                            this.$message.success(res.data.msg)
                            this.getData()
                        } else {
                            this.$message.error(res.data.msg)
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
            }
        },
        created() {
            this.getData()
        }
    }
</script>

<style scoped lang="less">
    #MyPost {
        width: 100%;
        min-height: calc(100vh - 220px);
        background: #f4f4f4;
        padding-top: 25px;
        padding-bottom: 100px;

        .post-content {
            width: 1200px;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;

            .post-nav {
                width: 280px;

                .nav-item {
                    width: 100%;
                    height: 60px;
                    background: white;
                    margin-bottom: 1px;
                    line-height: 60px;
                    /*padding-left: 32px;*/
                    box-sizing: border-box;
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                }

                .item-hover {
                    width: 4px;
                    height: 36px;
                    background: rgba(5, 160, 130, 1);
                    margin-right: 32px;
                    transition: all .5s;
                }

                .item-hover-null {
                    background: white;
                }
            }

            .post-list {
                width: 880px;

                .post-tab {
                    height: 60px;
                    background: white;
                    display: flex;
                    justify-content: flex-start;

                    .tab-item {
                        height: 60px;
                        line-height: 60px;

                        span {
                            &:nth-of-type(1) {
                                display: inline-block;
                                width: 56px;
                                margin: 0 26px;
                                height: 60px;
                            }
                        }

                        .nav-focus {
                            border-bottom: 2px solid rgba(5, 160, 130, 1);
                            color: rgba(5, 160, 130, 1);
                        }
                    }
                }

            }
        }
    }

    .item-block {
        width: 100%;

        .item-block-item {
            margin: 20px 0;
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px;
            transition: all .5s;

            &:hover {
                box-shadow: 0px 2px 16px 2px rgba(0, 0, 0, 0.1);
            }

            .item-block-banner {
                width: 216px;
                height: 142px;
                overflow: hidden;

                img {
                    width: 100%;
                    height: 100%;
                    transition: all .5s;

                    &:hover {
                        transform: scale(1.4);
                    }
                }
            }

            .item-block-info {
                width: calc(100% - 240px);
                height: 150px;

                p:nth-of-type(1) {
                    margin-top: 10px;
                    font-size: 18px;
                    img {
                        float: right;
                        width: 50px;
                        height: 50px;
                        cursor: pointer;
                    }
                }

                p:nth-of-type(2) {
                    font-size: 12px;
                    margin-top: 20px;
                    color: rgba(102, 102, 102, 1);
                    line-height: 18px;
                    height: 36px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                }

                p:nth-of-type(3) {
                    margin-top: 40px;
                    font-size: 12px;
                    color: rgba(153, 153, 153, 1);
                }
            }
        }
    }

    .pagination-post {
        margin: 54px auto;
        width: 100%;
        /*display: flex;*/
        /*justify-content: center;*/
        text-align: center;
    }

    .item-block-fishsite {
        width: calc(100% - 240px);
        height: 150px;

        > p:nth-of-type(1) {
            font-size: 18px;
            font-weight: bold;
            color: rgba(34, 34, 34, 1);
        }

        > div {
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            > img {
                margin-right: 10px;
            }
            span {
                margin-right: 10px;
            }
        }

        .fishsite-type {
            margin-top: 10px;
            display: flex;
            justify-items: flex-start;

            .fishsite-type-item {
                margin-right: 10px;
                width: 40px;
                height: 20px;
                background: rgba(138, 173, 231, 0.2);
                color: rgba(91, 142, 225, 1);
                border: 1px solid rgba(138, 173, 231, 1);
                opacity: 0.5;
                border-radius: 4px;
                font-size: 12px;
                text-align: center;
                line-height: 20px;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/views/user/MyPost.vue